import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'vectronic-details-top-bar-item',
  templateUrl: './details-top-bar-item.component.html',
  styleUrls: ['./details-top-bar-item.component.scss'],
  imports: [MatTooltipModule, CommonModule, MatIconModule, MatBadgeModule],
})
export class DetailsTopBarItemComponent {
  header = input<string>();
  value = input<string | number>();
  extraInfo = input<string>();
  tooltip = input<string>();
  isBold = input(false);
  icon = input<string>();
  badge = input<string | number>();
}
